import React from 'react';
import {ConfigApi, OrderApi, OrderTrackingStatus} from "../../../../services/Api/types";
import OrderPreparationStatusStatuses from "./OrderPreparationStatusStatuses";
import OrderPreparationStatusInfo from "./OrderPreparationStatusInfo";

interface Props {
    order: OrderApi;
    orderTrackingStatus: OrderTrackingStatus;
    onUpdate: (order: OrderApi) => void;
    config: ConfigApi;
}

const OrderOtherTypePreparationStatusComponent = ({orderTrackingStatus, order, onUpdate, config}: Props) => {
    return (
        <div>
            <OrderPreparationStatusStatuses order={order} orderTrackingStatus={orderTrackingStatus}/>
            <OrderPreparationStatusInfo order={order} orderTrackingStatus={orderTrackingStatus} onUpdate={onUpdate}
                                        config={config}/>
        </div>
    )
}

export default OrderOtherTypePreparationStatusComponent;